<template>
  <div class="container">
    <div class="card">
      <h1 class="title">AGB Generator</h1>

      <div class="form-group">
        <label>Company Name</label>
        <input
          v-model="companyName"
          type="text"
          placeholder="Enter your company name"
        />
      </div>

      <div class="form-group">
        <label>Business Type</label>
        <select v-model="businessType">
          <option value="E-Commerce">E-Commerce</option>
          <option value="Service">Service</option>
          <option value="Freelancer">Freelancer</option>
        </select>
      </div>

      <div class="form-group">
        <label>Description</label>
        <input
          v-model="content"
          type="text"
          placeholder="Describe your company"
        />
      </div>

      <button @click="generateAGB" class="btn-primary">Generate AGB</button>

      <div v-if="generatedAGB" class="output">
        <h2>Generated AGB</h2>
        <p>{{ generatedAGB }}</p>

        <div class="buttons">
          <button @click="copyAGB" class="btn-secondary">Copy</button>
          <button @click="downloadAGB" class="btn-download">Download</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AGBGenerator",
  data() {
    return {
      // Default values for the demo/mockup
      companyName: "eSell",
      businessType: "E-Commerce",
      content: "sell's e-prudcts like audio, videos",
      generatedAGB: "",
    };
  },
  methods: {
    async generateAGB() {
      // Instead of making an external fetch call,
      // we simulate the API response directly within the file.
      const mockResponse = {
        response: `Diese Allgemeinen Geschäftsbedingungen (AGB) regeln die vertraglichen Beziehungen zwischen ${this.companyName} (im Folgenden "Anbieter" genannt) und dem Kunden. Als ein Unternehmen im Bereich ${this.businessType} verpflichtet sich ${this.companyName}, seinen Kunden digitale Produkte und Dienstleistungen von höchster Qualität zu bieten. Unser Leistungsangebot umfasst unter anderem ${this.content} sowie weitere ergänzende Services, die im Rahmen unserer Geschäftstätigkeit erbracht werden.

Mit der Inanspruchnahme der Leistungen von ${this.companyName} akzeptiert der Kunde diese AGB in vollem Umfang. Alle Änderungen oder Ergänzungen der AGB werden dem Kunden rechtzeitig und in transparenter Form mitgeteilt. Der Vertragsgegenstand umfasst die Nutzung der bereitgestellten digitalen Inhalte und Dienstleistungen, wobei ${this.companyName} stets bestrebt ist, den aktuellen gesetzlichen Vorgaben zu entsprechen und die berechtigten Interessen seiner Kunden zu wahren.

Der Kunde verpflichtet sich, alle zur Nutzung der Services notwendigen Angaben vollständig und wahrheitsgemäß zu machen. Etwaige Haftungsbeschränkungen, Gewährleistungsrechte und weitere vertragliche Vereinbarungen richten sich nach den geltenden gesetzlichen Bestimmungen. ${this.companyName} haftet nicht für Schäden, die aus einer unsachgemäßen Nutzung der digitalen Inhalte oder aufgrund höherer Gewalt entstehen.

Zudem behält sich ${this.companyName} das Recht vor, technische Änderungen an den angebotenen Leistungen vorzunehmen, sofern dies zur Verbesserung des Services oder zur Einhaltung gesetzlicher Vorschriften erforderlich ist. Der Kunde wird verpflichtet, sich regelmäßig über die aktuellen AGB zu informieren und diese zu akzeptieren.

Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise unwirksam sein, so wird dadurch die Gültigkeit der übrigen Bestimmungen nicht berührt. In einem solchen Fall gilt eine Regelung als vereinbart, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung am nächsten kommt.

Für sämtliche Streitigkeiten aus dem Vertragsverhältnis gilt das Recht der Bundesrepublik Deutschland, und als Gerichtsstand wird, soweit gesetzlich zulässig, der Geschäftssitz von ${this.companyName} vereinbart.

Indem der Kunde diese AGB akzeptiert, erklärt er, dass er den Inhalt der Bedingungen verstanden hat und sich zur Einhaltung verpflichtet.`,
      };

      this.generatedAGB = `AGB für ${this.companyName}\nBusiness Type: ${this.businessType}\n\n${mockResponse.response}`;
    },

    copyAGB() {
      navigator.clipboard.writeText(this.generatedAGB);
      alert("AGB copied to clipboard!");
    },
    downloadAGB() {
      const blob = new Blob([this.generatedAGB], { type: "text/plain" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "AGB.txt";
      link.click();
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f3f4f6;
  padding: 20px;
}

.card {
  width: 100%;
  max-width: 600px;
  background: white;
  padding: 30px;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

/* Typography */
.title {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

/* Form Elements */
.form-group {
  margin-bottom: 15px;
}

label {
  font-weight: 600;
  color: #444;
  display: block;
  margin-bottom: 5px;
}

input,
select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 8px;
  transition: 0.3s;
}

input:focus,
select:focus {
  border-color: #333;
  outline: none;
}

/* Buttons */
.btn-primary {
  width: 100%;
  padding: 12px;
  background: #333;
  color: white;
  font-weight: bold;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s;
}

.btn-primary:hover {
  background: #444;
}

.btn-secondary,
.btn-download {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.btn-secondary {
  background: #e5e7eb;
  color: #333;
}

.btn-secondary:hover {
  background: #d1d5db;
}

.btn-download {
  background: #10b981;
  color: white;
}

.btn-download:hover {
  background: #059669;
}

/* Output Section */
.output {
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.output h2 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.output p {
  white-space: pre-line;
  color: #555;
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
